var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse-list vch-grid",class:{ 'row pdp-collapse': _vm.productPage }},[_c('div',{class:{ 'vch-col-12 collapse-content': _vm.productPage }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }